import styled from "styled-components"

export const PatentContainer = styled.div`
  padding: 60px 0;

  h3 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 18px;
  }

  p {
    color: ${props => props.theme.colors.darkBlue};
    .bright-blue {
      color: ${props => props.theme.colors.brightBlue};
      font-weight: 600;
    }
  }

  .row {
    margin-top: 24px;
    .col-lg-6:last-child {
      border-right: none;
    }
    .col-lg-6 {
      border-right: 2px solid #c6e5f4;

      @media (max-width: 768px) {
        border-right: none;
      }

      @media (max-width: 768px) {
        margin-bottom: 20px;
      }

      ul {
        margin: 20px 0px 0px 20px;
        li {
          margin: 8px 0;
          // list-style-type: disc;
          .bright-blue {
            color: ${props => props.theme.colors.brightBlue};
            font-weight: 600;
          }
          &::before {
            content: "•" !important;
            color: ${props => props.theme.colors.darkBlue};
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
          }
        }
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
